module.exports = __webpack_public_path__ + "img/running_gears.c0ec7191.gif";